var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_781_265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 20L17.3333 14.6667L15.4667 12.8L13.3333 14.9333V9.33333H10.6667V14.9333L8.53333 12.8L6.66667 14.6667L12 20ZM2.66667 6.66667V21.3333H21.3333V6.66667H2.66667ZM2.66667 24C1.93333 24 1.3 23.7444 0.766667 23.2333C0.255556 22.7 0 22.0667 0 21.3333V4.7C0 4.38889 0.0444447 4.08889 0.133334 3.8C0.244445 3.51111 0.4 3.24444 0.6 3L2.26667 0.966667C2.51111 0.655556 2.81111 0.422222 3.16667 0.266666C3.54444 0.0888888 3.93333 0 4.33333 0H19.6667C20.0667 0 20.4444 0.0888888 20.8 0.266666C21.1778 0.422222 21.4889 0.655556 21.7333 0.966667L23.4 3C23.6 3.24444 23.7444 3.51111 23.8333 3.8C23.9444 4.08889 24 4.38889 24 4.7V21.3333C24 22.0667 23.7333 22.7 23.2 23.2333C22.6889 23.7444 22.0667 24 21.3333 24H2.66667ZM3.2 4H20.8L19.6667 2.66667H4.33333L3.2 4Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_781_265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.043457)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.30c60aa4bd26fddd08dc4b813e3be9da.svg";
export { ForwardRef as ReactComponent };